const Treatment = ({ name, date }) => {
  return (
    <div className="row">
      <span className="col">{date}</span>
      <span className="col">{name}</span>
    </div>
  );
};

export default Treatment;
